module.exports = __webpack_public_path__ + "static/media/white.24e3572b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/white.png
// module id = 884
// module chunks = 0